import { FormattedMessage } from 'react-intl';

type ClusterSidebarFooterProps = {
    onClose?: () => void;
};

export const ClusterSidebarFooter = ({ onClose = () => {} }: ClusterSidebarFooterProps) => (
    <div>
        <button className='btn btn-default' type='button' onClick={onClose}>
            <FormattedMessage id='intl-msg:livemonitor.close' />
        </button>
    </div>
);
